import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import CustomToast from '@componentsShared/CustomToast';
import { checkTestFlag } from "@/common/config/websiteConfig";
var ToastService = /*#__PURE__*/function () {
  function ToastService() {
    _classCallCheck(this, ToastService);
    _defineProperty(this, "listeners", []);
  }
  return _createClass(ToastService, [{
    key: "addListener",
    value: function addListener(callback) {
      this.listeners.push(callback);
    }
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      this.listeners = this.listeners.filter(function (listener) {
        return listener !== callback;
      });
    }
  }, {
    key: "showToast",
    value: function showToast(params, event) {
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "dataLayer";
      if (checkTestFlag('TEST_SHOW_DATALAYER')) {
        var message = {
          params: params,
          event: event,
          title: title
        };
        this.listeners.forEach(function (listener) {
          return listener(message);
        });
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!ToastService.instance) {
        ToastService.instance = new ToastService();
      }
      return ToastService.instance;
    }
  }]);
}();
export var toastService = ToastService.getInstance();
export function ToastContainer() {
  useEffect(function () {
    var handleToast = function handleToast(_ref) {
      var params = _ref.params,
        event = _ref.event,
        title = _ref.title;
      var paramsCopy = _objectSpread({}, params);
      delete paramsCopy.user_country;
      delete paramsCopy.language;
      toast(function (t) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            direction: "ltr"
          }
        }, /*#__PURE__*/React.createElement(CustomToast, {
          title: title + " " + event,
          message: JSON.stringify(paramsCopy, null, 2),
          onClose: function onClose() {
            return toast.dismiss(t.id);
          },
          onCloseAll: function onCloseAll() {
            return toast.dismiss();
          }
        }));
      }, {
        duration: 100000000,
        position: "bottom-left",
        style: {
          direction: "ltr",
          border: "0",
          padding: "0",
          color: "transparent",
          margin: "0"
        }
      });
    };
    toastService.addListener(handleToast);
    return function () {
      return toastService.removeListener(handleToast);
    };
  }, []);
  return null;
}